import { render, staticRenderFns } from "./dppgeneralnoti.vue?vue&type=template&id=335f232a&scoped=true&"
import script from "./dppgeneralnoti.vue?vue&type=script&lang=js&"
export * from "./dppgeneralnoti.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./dppgeneralnoti.vue?vue&type=style&index=1&id=335f232a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335f232a",
  null
  
)

export default component.exports